import { api } from "../../server/request";
import { handleError, handleResponse } from "../responseUtil";
import { SET_LOADING, SAVE_SSO_CONFIG, UPDATE_SSO_CONFIG, DELETE_SSO_CONFIG, VERIFY_SSO_CONNECTION, FETCH_SSO_ORGANIZATIONS, SET_SSO_ORGANIZATIONS_LOADING, SET_DOMAIN_SSO_CHECK, SET_SSO_CODE } from "../types";

export const saveSSOConfig = (payload) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .postRequest(`/iam/sso/config`, payload)
        .then((res) => handleResponse(res, dispatch, SAVE_SSO_CONFIG))
        .catch((err) => handleError(err, dispatch));
};

export const updateSSOConfig = (payload) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .putRequest(`/iam/sso/config`, payload)
        .then((res) => handleResponse(res, dispatch, UPDATE_SSO_CONFIG))
        .catch((err) => handleError(err, dispatch));
};

export const deleteSSOConfig = (dpId) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .deleteRequest(`/iam/sso/config/${dpId}`)
        .then((res) => handleResponse(res, dispatch, DELETE_SSO_CONFIG))
        .catch((err) => handleError(err, dispatch));
};

export const verifySSOConnection = (dpId) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .postRequest(`/iam/sso/verify`, { dpId })
        .then((res) => handleResponse(res, dispatch, VERIFY_SSO_CONNECTION))
        .catch((err) => handleError(err, dispatch));
};

export const fetchSSOOrganizations = () => (dispatch) => {
    dispatch({ type: SET_SSO_ORGANIZATIONS_LOADING, payload: true });
    api
        .getRequestOut(`/iam/sso/dp`)
        .then((res) => {
            const body = res?.data || res;
            if (body?.success && body?.data?.organizations) {
                dispatch({ type: FETCH_SSO_ORGANIZATIONS, payload: body.data.organizations });
            } else {
                dispatch({ type: FETCH_SSO_ORGANIZATIONS, payload: [] });
            }
            dispatch({ type: SET_SSO_ORGANIZATIONS_LOADING, payload: false });
        })
        .catch((err) => {
            dispatch({ type: FETCH_SSO_ORGANIZATIONS, payload: [] });
            dispatch({ type: SET_SSO_ORGANIZATIONS_LOADING, payload: false });
        });
};

export const setSSOCode = (payload) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .putRequest(`/iam/sso/code`, payload)
        .then((res) => handleResponse(res, dispatch, SET_SSO_CODE))
        .catch((err) => handleError(err, dispatch));
};

export const checkDomainSSO = (domain) => (dispatch) => {
    if (!domain) {
        dispatch({ type: SET_DOMAIN_SSO_CHECK, payload: null });
        return;
    }
    api
        .getRequestOut(`/iam/sso/dp-check?dp_domain=${encodeURIComponent(domain)}`)
        .then((res) => {
            const body = res?.data || res;
            if (body?.success && body?.data) {
                dispatch({ type: SET_DOMAIN_SSO_CHECK, payload: body.data });
            } else {
                dispatch({ type: SET_DOMAIN_SSO_CHECK, payload: null });
            }
        })
        .catch(() => {
            dispatch({ type: SET_DOMAIN_SSO_CHECK, payload: null });
        });
};
